import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import { configureAmplify } from './lib/amplify';
import { ToastProvider } from './lib/use-toast';
import { log, getLogLevel } from './lib/log';
import { DEMO } from './lib/demo';
import './i18n';
import './index.css';

log.info('app boot', {
  mode: import.meta.env.MODE,
  demo: DEMO,
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || '(same-origin)',
  logLevel: getLogLevel(),
});

configureAmplify();

// PWA service-worker registration + "new version" prompt lives in
// components/pwa-updater.tsx (rendered in App), guarded against file:// hosting.

// Surface uncaught errors + rejected promises in the console with our tag so
// testers (and console-reading automation) see them attributed, not just raw.
window.addEventListener('error', (e) => {
  log.error('window error', { message: e.message, source: e.filename, line: e.lineno });
});
window.addEventListener('unhandledrejection', (e) => {
  log.error('unhandled promise rejection', { reason: String(e.reason) });
});

// HashRouter so the same bundle works on static hosting without server-side route config.
const queryClient = new QueryClient();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <HashRouter>
          <App />
        </HashRouter>
      </ToastProvider>
    </QueryClientProvider>
  </React.StrictMode>
);
